import type { SxProps, Theme } from "@mui/material";
import { formPrimary, mergeSelectSx } from "@config/theme/formControls";
import {
	menuPaperSx,
	menuZIndexSx,
	selectRenderValuePlaceholderSx,
	selectRenderValueSelectedSx,
	menuItemSx,
} from "../../Select/styles/Select.styles";

/** SelectWithSearch uses the same field chrome as AppSelect; only layout tweaks here. */
export const selectWithSearchSx = (error?: boolean): SxProps<Theme> =>
	mergeSelectSx(error, undefined, {
		"& .MuiOutlinedInput-root": {
			"& .MuiInputAdornment-root": {
				marginRight: "2px",
			},
		},
		"& .MuiSelect-select": {
			paddingLeft: "12px",
		},
	});

export const menuPaperSxWithScroll: SxProps<Theme> = {
	...menuPaperSx,
	maxHeight: 300,
	overflow: "auto",
};

export const menuListPropsSx: SxProps<Theme> = {
	maxHeight: "300px",
	overflow: "auto",
};

export const searchMenuItemSx: SxProps<Theme> = {
	py: 1.5,
	px: 2,
	cursor: "text",
	"&:hover": {
		backgroundColor: "transparent !important",
	},
	"&:focus": {
		backgroundColor: "transparent !important",
	},
};

export const searchTextFieldSx: SxProps<Theme> = {
	"& .MuiOutlinedInput-root": {
		borderRadius: 1,
		fontSize: "12px",
		backgroundColor: "#ffffff",
		"& fieldset": {
			borderColor: "#E2E8F0",
		},
		"&:hover": {
			backgroundColor: "#ffffff",
			"& fieldset": {
				borderColor: "#CBD5E1",
			},
		},
		"&.Mui-focused": {
			backgroundColor: "#ffffff",
			"& fieldset": {
				borderColor: formPrimary,
				borderWidth: "1px",
			},
		},
	},
};

export const loadingMenuItemSx: SxProps<Theme> = {
	display: "flex",
	justifyContent: "center",
	width: "100%",
	py: 2,
	color: "#98A2B3",
	fontSize: "12px",
};

export const noResultsMenuItemSx: SxProps<Theme> = {
	display: "flex",
	justifyContent: "center",
	width: "100%",
	py: 2,
	color: "#98A2B3",
	fontSize: "12px",
};

export const loadingIndicatorSx: SxProps<Theme> = {
	display: "flex",
	justifyContent: "center",
	width: "100%",
	py: 1,
};

export { selectRenderValuePlaceholderSx, selectRenderValueSelectedSx, menuItemSx, menuZIndexSx };
